<template>
  <div class="plastic-bags-for-packaging with-slider">
    <!--type slider (desktop)-->
    <slider-select
      v-if="fields[PlasticBagsForPackagingFields.type].options?.length"
      v-model="form.type"
      class="main-slider"
    >
      <slider-select-option
        v-for="option in fields[PlasticBagsForPackagingLabels.type].options"
        :key="option.value"
        :value="option.value"
        :label="option.title"
        :image-src="uploadsUrl(option?.thumbnail?.data?.attributes.url || '')"
      />
    </slider-select>
    <i-form
      v-scroll-to-invalid
      class="form"
      name="plastic-bags-for-packaging-form"
      @submit="handleSubmit"
    >
      <div class="type">
        <strapi-label :label="labels[PlasticBagsForPackagingFields.type]" />
        <div class="form-field-group">
          <!--type field-->
          <zaproo-select
            v-if="fields[PlasticBagsForPackagingFields.type]"
            v-model="form.type"
            :removable="false"
            name="type"
            searchable
            highlight
            :no-result-label="$t('No results found')"
            no-result-class="text-neutral-900/50 text-center !py-2 !px-4"
            :rules="fieldRules[PlasticBagsForPackagingFields.type]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsForPackagingFields.type]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[PlasticBagsForPackagingFields.type]
                .options"
              :key="option.value"
              :value="option.value"
              :label="option.title"
            />
          </zaproo-select>
        </div>
      </div>

      <div
        v-if="fields[PlasticBagsForPackagingFields.type].options?.length"
        class="form-slider"
      >
        <!--type slider (max to desktop)-->
        <slider-select v-model="form.type">
          <slider-select-option
            v-for="option in fields[PlasticBagsForPackagingFields.type].options"
            :key="option.value"
            :value="option.value"
            :label="option.value"
            :image-src="
              uploadsUrl(option?.thumbnail?.data?.attributes.url || '')
            "
          />
        </slider-select>
      </div>

      <div class="dimensions mt-6">
        <strapi-label
          :label="labels[PlasticBagsForPackagingLabels.dimensions]"
        />
        <div class="form-field-third">
          <!--length field-->
          <zaproo-input
            v-if="fields[PlasticBagsForPackagingFields.length]"
            v-model="form.length"
            type="number"
            name="length"
            :rules="fieldRules[PlasticBagsForPackagingFields.length]"
            :placeholder="
              fields[PlasticBagsForPackagingFields.length].placeholder
            "
            :description="
              fields[PlasticBagsForPackagingFields.length].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsForPackagingFields.length]"
              />
            </template>
          </zaproo-input>

          <!--width field-->
          <zaproo-input
            v-if="fields[PlasticBagsForPackagingFields.width]"
            v-model="form.width"
            type="number"
            name="width"
            :rules="fieldRules[PlasticBagsForPackagingFields.width]"
            :placeholder="
              fields[PlasticBagsForPackagingFields.width].placeholder
            "
            :description="
              fields[PlasticBagsForPackagingFields.width].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsForPackagingFields.width]"
              />
            </template>
          </zaproo-input>

          <!--folding field-->
          <zaproo-input
            v-if="fields[PlasticBagsForPackagingFields.folding]"
            v-model="form.folding"
            type="number"
            name="folding"
            :rules="fieldRules[PlasticBagsForPackagingFields.folding]"
            :placeholder="
              fields[PlasticBagsForPackagingFields.folding].placeholder
            "
            :description="
              fields[PlasticBagsForPackagingFields.folding].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsForPackagingFields.folding]"
              />
            </template>
          </zaproo-input>
        </div>
      </div>

      <div class="material mt-6">
        <strapi-label
          v-if="labels[PlasticBagsForPackagingLabels.material]"
          :label="labels[PlasticBagsForPackagingLabels.material]"
        />
        <div class="form-field-group">
          <!--material field-->
          <zaproo-select
            v-if="fields[PlasticBagsForPackagingFields.material]"
            v-model="form.material"
            :removable="false"
            name="material"
            :rules="fieldRules[PlasticBagsForPackagingFields.material]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsForPackagingFields.material]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[PlasticBagsForPackagingFields.material]
                .options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--thickness field-->
          <zaproo-input
            v-if="fields[PlasticBagsForPackagingFields.thickness]"
            v-model="form.thickness"
            type="number"
            name="thickness"
            :rules="fieldRules[PlasticBagsForPackagingFields.thickness]"
            :placeholder="
              fields[PlasticBagsForPackagingFields.thickness].placeholder
            "
            :description="
              fields[PlasticBagsForPackagingFields.thickness].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsForPackagingFields.thickness]"
              />
            </template>
          </zaproo-input>
        </div>
        <div class="form-field-group">
          <!--mainColor field-->
          <zaproo-select
            v-if="fields[PlasticBagsForPackagingFields.mainColor]"
            v-model="form.mainColor"
            :removable="false"
            name="mainColor"
            :rules="fieldRules[PlasticBagsForPackagingFields.mainColor]"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsForPackagingFields.mainColor]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[PlasticBagsForPackagingFields.mainColor]
                .options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--otherMainColor field-->
          <zaproo-input
            v-if="
              isOtherMainColor &&
              fields[PlasticBagsForPackagingFields.otherMainColor]
            "
            v-model="form.otherMainColor"
            name="otherMainColor"
            :rules="fieldRules[PlasticBagsForPackagingFields.otherMainColor]"
            :placeholder="
              fields[PlasticBagsForPackagingFields.otherMainColor].placeholder
            "
            :description="
              fields[PlasticBagsForPackagingFields.otherMainColor].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsForPackagingFields.otherMainColor]"
              />
            </template>
          </zaproo-input>
        </div>
      </div>

      <div class="print mt-6">
        <strapi-label
          v-if="labels[PlasticBagsForPackagingLabels.print]"
          :label="labels[PlasticBagsForPackagingLabels.print]"
        />
        <div class="form-field-group">
          <!--numberOfPrintColorsFirstSide field-->
          <zaproo-select
            v-if="
              fields[PlasticBagsForPackagingFields.numberOfPrintColorsFirstSide]
            "
            v-model="form.numberOfPrintColorsFirstSide"
            :removable="false"
            :rules="
              fieldRules[
                PlasticBagsForPackagingFields.numberOfPrintColorsFirstSide
              ]
            "
            dropdown-classes="py-2 mt-2"
            name="numberOfPrintColorsFirstSide"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="
                  fields[
                    PlasticBagsForPackagingFields.numberOfPrintColorsFirstSide
                  ]
                "
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                PlasticBagsForPackagingFields.numberOfPrintColorsFirstSide
              ].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--firstSidePrintArea field-->
          <zaproo-select
            v-if="
              isPrintColorsFirstSide &&
              fields[PlasticBagsForPackagingFields.firstSidePrintArea]
            "
            v-model="form.firstSidePrintArea"
            :removable="false"
            :rules="
              fieldRules[PlasticBagsForPackagingFields.firstSidePrintArea]
            "
            dropdown-classes="py-2 mt-2"
            name="firstSidePrintArea"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="
                  fields[PlasticBagsForPackagingFields.firstSidePrintArea]
                "
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                PlasticBagsForPackagingFields.firstSidePrintArea
              ].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>
        </div>

        <div class="form-field-group">
          <!--numberOfPrintColorsSecondSide field-->
          <zaproo-select
            v-if="[PlasticBagsForPackagingFields.numberOfPrintColorsSecondSide]"
            v-model="form.numberOfPrintColorsSecondSide"
            :removable="false"
            :rules="
              fieldRules[
                PlasticBagsForPackagingFields.numberOfPrintColorsSecondSide
              ]
            "
            dropdown-classes="py-2 mt-2"
            name="numberOfPrintColorsSecondSide"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="
                  fields[
                    PlasticBagsForPackagingFields.numberOfPrintColorsSecondSide
                  ]
                "
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                PlasticBagsForPackagingFields.numberOfPrintColorsSecondSide
              ].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--secondSidePrintArea field-->
          <zaproo-select
            v-if="
              isPrintColorsSecondSide &&
              fields[PlasticBagsForPackagingFields.secondSidePrintArea]
            "
            v-model="form.secondSidePrintArea"
            :removable="false"
            :rules="
              fieldRules[PlasticBagsForPackagingFields.secondSidePrintArea]
            "
            dropdown-classes="py-2 mt-2"
            name="secondSidePrintArea"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="
                  fields[PlasticBagsForPackagingFields.secondSidePrintArea]
                "
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                PlasticBagsForPackagingFields.secondSidePrintArea
              ].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>
        </div>

        <div class="form-field-group">
          <!--designFile field-->
          <zaproo-file-input
            v-if="
              isPrintDesignFile &&
              fields[PlasticBagsForPackagingFields.designFile]
            "
            v-model="form.designFile"
            class="mt-3"
            name="designFiles"
            :rules="fieldRules[PlasticBagsForPackagingFields.designFile]"
            multiple
            :total-size-of-files="INPUT_FILE_TOTAL_SIZE"
            :placeholder="
              fields[PlasticBagsForPackagingFields.designFile].placeholder
            "
            file-item-classes="h-10"
            remove-button-classes="!p-0"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PlasticBagsForPackagingFields.designFile]"
              />
            </template>
            <template #removeFileText>
              <icons-icon-trash />
              {{ $t("Remove") }}
            </template>
            <template #fileError="{ errors, clear }">
              <div class="mb-2 grid grid-cols-1 gap-2">
                <file-input-error-notification
                  :clear="clear"
                  :errors="errors"
                />
              </div>
            </template>
          </zaproo-file-input>
        </div>
      </div>

      <special-order-form-general-contacts-part
        v-model="form"
        class="general-contacts-form"
        :loading="loading"
      >
        <!--amountPcs field-->
        <zaproo-input
          v-if="fields[PlasticBagsForPackagingFields.amountPcs]"
          v-model="form.amountPcs"
          type="number"
          name="amountPcs"
          :rules="fieldRules[PlasticBagsForPackagingFields.amountPcs]"
          :placeholder="
            fields[PlasticBagsForPackagingFields.amountPcs].placeholder
          "
          :description="
            fields[PlasticBagsForPackagingFields.amountPcs].description
          "
          class="form-field"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[PlasticBagsForPackagingFields.amountPcs]"
            />
          </template>
        </zaproo-input>
      </special-order-form-general-contacts-part>
    </i-form>
  </div>
</template>

<script setup lang="ts">
import { Form as IForm, FormActions } from "vee-validate";
import SpecialOrderFormInputLabel from "../SpecialOrderFormInputLabel.vue";
import {
  PlasticBagsForPackagingLabels,
  PlasticBagsForPackagingFields,
} from "./types";
import type {
  StrapiField,
  StrapiLabel as StrapiLabelType,
  StrapiSpecialOrders,
} from "~/types/strapi";

import { getFieldDefaultModel } from "~/modules/special-orders/helpers";

import StrapiLabel from "~/components/strapi/components/shared/StrapiLabel.vue";
import SliderSelect from "~/modules/special-orders/components/SliderSelect/SliderSelect.vue";
import SliderSelectOption from "~/modules/special-orders/components/SliderSelect/SliderSelectOption.vue";
import FileInputErrorNotification from "~/modules/special-orders/components/SpecialOrderForm/FileInputErrorNotification.vue";
import { INPUT_FILE_TOTAL_SIZE } from "~/modules/special-orders/variables";
import { useFormFieldCleaner } from "~/modules/special-orders/composables/useFormFieldCleaner";

const props = defineProps<{
  specialOrder: StrapiSpecialOrders;
}>();

const { uploadsUrl } = useStrapiExtend();

const { collection: labelCollection } =
  useSpecialOrderUidDictionary<StrapiLabelType>(props.specialOrder.labels);

const { collection: fieldsCollection } =
  useSpecialOrderUidDictionary<StrapiField>(props.specialOrder.fields);

const { sendRequest, loading } = useSpecialOrdersSubmit(props.specialOrder);

const labels = computed(() => labelCollection(PlasticBagsForPackagingLabels));
const fields = computed(() => fieldsCollection(PlasticBagsForPackagingFields));
const fieldRules = useSpecialOrderFieldRules<
  typeof PlasticBagsForPackagingFields
>(fields.value);

const form = ref<ReturnType<typeof resetForm>>(resetForm());

const isPrintColorsFirstSide = computed(
  () => form.value.numberOfPrintColorsFirstSide !== "0",
);

const isPrintColorsSecondSide = computed(
  () => form.value.numberOfPrintColorsSecondSide !== "0",
);

const isPrintDesignFile = computed<boolean>(
  () => isPrintColorsFirstSide.value || isPrintColorsSecondSide.value,
);

const isOtherMainColor = computed(() => form.value.mainColor === "other");

function resetForm() {
  return {
    type: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.type],
    ),
    length: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.length],
    ),
    width: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.width],
    ),
    folding: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.folding],
    ),
    material: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.material],
    ),
    thickness: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.thickness],
    ),
    mainColor: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.mainColor],
    ),
    otherMainColor: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.otherMainColor],
    ),
    numberOfPrintColorsFirstSide: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.numberOfPrintColorsFirstSide],
    ),
    firstSidePrintArea: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.firstSidePrintArea],
    ),
    numberOfPrintColorsSecondSide: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.numberOfPrintColorsSecondSide],
    ),
    secondSidePrintArea: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.secondSidePrintArea],
    ),
    amountPcs: getFieldDefaultModel(
      fields.value[PlasticBagsForPackagingFields.amountPcs],
    ),
    designFile: [],
    email: "",
    phone: "",
    additionalInfo: "",
  };
}

async function handleSubmit(
  _: Record<string, unknown>,
  { resetForm: reset }: FormActions<Record<string, unknown>>,
) {
  await sendRequest(form.value);
  reset();
  form.value = resetForm();
}

useFormFieldCleaner(
  {
    otherMainColor: {
      default: () =>
        getFieldDefaultModel(
          fields.value[PlasticBagsForPackagingFields.otherMainColor],
        ),
      ref: isOtherMainColor,
    },
    designFile: {
      default: () => [],
      ref: isPrintDesignFile,
    },
    firstSidePrintArea: {
      default: () =>
        getFieldDefaultModel(
          fields.value[PlasticBagsForPackagingFields.firstSidePrintArea],
        ),
      ref: isPrintColorsFirstSide,
    },
    secondSidePrintArea: {
      default: () =>
        getFieldDefaultModel(
          fields.value[PlasticBagsForPackagingFields.secondSidePrintArea],
        ),
      ref: isPrintColorsSecondSide,
    },
  },
  form,
);
</script>
